//import process from "process";

const development = process.env.NODE_ENV === 'development';

export function isDev()
{
    return development;
}

let isAuthenticated = localStorage.getItem('isAuthenticated');
if (isAuthenticated === null) 
{
  isAuthenticated = true;
  localStorage.setItem('isAuthenticated', true);
} 
else 
{
  isAuthenticated = isAuthenticated === 'true';
}

export function SetAuthenticated(value) 
{
  isAuthenticated = value;
  localStorage.setItem('isAuthenticated', value);
}

export function IsAuthenticated() 
{
  return isAuthenticated;
}